var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 1,
    fill: "currentColor",
    stroke: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 10,
    r: 1,
    fill: "currentColor",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16c1.2-1.5 2.7-2.5 4-2.5s2.8 1 4 2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.745edc1fcf6f4f96d1d38b976ba4ebd2.svg";
export { ForwardRef as ReactComponent };